// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nbGq","top":"styles_top__3Eoas"};